import { render, staticRenderFns } from "./RewardsAsideImage.vue?vue&type=template&id=7b124d1c&scoped=true&"
import script from "./RewardsAsideImage.vue?vue&type=script&lang=js&"
export * from "./RewardsAsideImage.vue?vue&type=script&lang=js&"
import style0 from "./RewardsAsideImage.vue?vue&type=style&index=0&id=7b124d1c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b124d1c",
  null
  
)

export default component.exports